import Vue from 'vue'
import Router from 'vue-router'
import routes from "./routes/routes"
import affiliateRoutes from "./routes/affiliate-routes"
import manageRoutes from "./routes/manage-routes"
import termsRoutes from "./routes/terms-routes"
import noPermissionRoutes from "./routes/no-permission-routes"
import { MessageBox } from 'element-ui'
import i18n from '@/locales'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes: [
    ...routes,
    ...affiliateRoutes,
    ...manageRoutes,
    ...termsRoutes,
    ...noPermissionRoutes,
    {
      path: '/:path(.*)',
      component: () => import('@/views/404.vue'),
      name: 'Page404',
      meta: {skipLoginCheck: true}
    }
  ]
})
const isManageReg = /^\/manage\//
const isAffiliateReg = /^\/affiliate\//

router.beforeEach((to, from, next) => {
  document.body.style = {}
  const maintenanceBegin = Date.UTC(2025, 8, 29, 19, 0, 0)
  const maintenanceEnd = Date.UTC(2025, 8, 29, 20, 0, 0)
  let currentTime = Date.now()
  //替换本地时间-测试使用
  if(localStorage.getItem('maintenanceCurTime')) {
      currentTime = new Date(localStorage.getItem('maintenanceCurTime'))
  }
  const isMaintenance = maintenanceBegin <= currentTime && currentTime <= maintenanceEnd
  console.log('maintenance mode:', isMaintenance)
  localStorage.setItem('isMaintenance', isMaintenance)
  if (isMaintenance && !['Home', 'JaTerms', 'Terms', 'Page404', 'ProductMedia'].includes(to.name) && to.name && sessionStorage.getItem('passport') !== 'kkparVIP') {
    MessageBox.alert(i18n.t('common.alert.MAINTENANCE.message'),
      i18n.t('common.alert.MAINTENANCE.title'),
    {
      confirmButtonText: 'OK',
      callback: () => {
      },
      onClose() {
      }
    })
    if(to.path == '/') {
      return next()
    } else {
      return next('/')
    }
  }
  // handle homepage lang path
  if (to.path === '/') {
    localStorage.setItem('lang', localStorage.getItem('lang') || 'en')
  }

  if (to.path === '/zh-tw') {
    localStorage.setItem('lang', 'zh-tw')
  }
  if (to.path === '/en') {
    localStorage.setItem('lang', 'en')
  }
  if (to.path === '/ja') {
    localStorage.setItem('lang', 'ja')
  }
  if (to.path === '/ko') {
    localStorage.setItem('lang', 'ko')
  }
  if (to.meta.skipLoginCheck) {
    // 跳过登录检查
    next()
    return
  }
  let isKKpartners = 0
  try {
    isKKpartners = Number(localStorage.getItem('isKKpartners'))
  } catch (error) {}
  if (!localStorage.getItem('authToken')) {
    next({
      path: '/login',
      query: { redirectPath: to.fullPath }
    })
    return
  }
  if (!isKKpartners && isManageReg.test(to.fullPath)) {
    // 联盟用户进入管理端页面
    next('/no-permission')
    return
  }
  if (isKKpartners && isAffiliateReg.test(to.fullPath) && isKKpartners === 2 ) {
    // 没有联盟资料的管理员尝试进入管理
    next('/no-permission')
    return
  }
  next()
})
router.afterEach((to) => {
  if (isManageReg.test(to.fullPath)) {
    localStorage.setItem('extraChannel', 'MANAGE')
  }
  if (isAffiliateReg.test(to.fullPath)) {
    localStorage.setItem('extraChannel', 'KKPARTNERS')
  }
})

export default router
